import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-item-gas-meter',
  template: ``,
  styleUrls: []
})
export class ItemGasMeterComponent {
  @Input() meter: any = {};
}
